"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _reactRouterDom = require("react-router-dom");
var _dateFns = require("date-fns");
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _APSelect = _interopRequireDefault(require("../common/APSelect/APSelect"));
var _APDatePicker = _interopRequireDefault(require("../common/APDatePicker/APDatePicker"));
var _APButton = _interopRequireDefault(require("../common/APButton"));
var _ProductIconContainer = _interopRequireDefault(require("../common/ProductIcon/ProductIconContainer"));
var _path = _interopRequireDefault(require("../../helpers/path"));
require("./ActivityPageComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var bemClasses = (0, _cssClassesHelper.getBEMClasses)('activity_page_component');
var ActivityPageComponent = /*#__PURE__*/function (_React$Component) {
  function ActivityPageComponent(props) {
    var _this;
    _classCallCheck(this, ActivityPageComponent);
    _this = _callSuper(this, ActivityPageComponent, [props]);
    _defineProperty(_this, "onComponentSelect", function (value) {
      _this.props.history.push((0, _path["default"])(value));
    });
    _defineProperty(_this, "renderComponentSelector", function () {
      var t = _this.props.t;
      if (_this.props.width <= 1280) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: bemClasses('selector-container', ['component', 'without-icon'])
        }, /*#__PURE__*/_react["default"].createElement(_APSelect["default"], {
          onSelect: function onSelect(value) {
            return _this.onComponentSelect(value);
          },
          name: "component",
          customClass: bemClasses(),
          showTriangles: true,
          options: [{
            value: 'orders',
            label: t('Orders')
          }, {
            value: 'deposit-withdraw',
            label: t('Withdraw/Deposit')
          }]
        }));
      } else {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: bemClasses('double-link-container')
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: bemClasses('link-container')
        }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.NavLink, {
          className: bemClasses('link'),
          to: '/activity/orders',
          activeClassName: bemClasses('link', 'active')
        }, t('Orders'))), /*#__PURE__*/_react["default"].createElement("div", {
          className: bemClasses('devider')
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: bemClasses('link-container')
        }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.NavLink, {
          className: bemClasses('link'),
          to: '/activity/deposit-withdraw',
          activeClassName: bemClasses('link', 'active')
        }, t('Withdrawals & Deposits'))));
      }
    });
    _this.state = {};
    return _this;
  }
  _inherits(ActivityPageComponent, _React$Component);
  return _createClass(ActivityPageComponent, [{
    key: "render",
    value: function render() {
      var t = this.props.t;
      var _this$props = this.props,
        products = _this$props.products,
        productManifest = _this$props.productManifest,
        formObj = _this$props.formObj,
        selectPositionAndSave = _this$props.selectPositionAndSave,
        clearFilter = _this$props.clearFilter,
        handleSubmit = _this$props.handleSubmit,
        component = _this$props.component;
      var selectedProduct = products.find(function (p) {
        return p.ProductId.toString() === formObj.values.product.toString();
      });
      var productOptions = products.map(function (product) {
        var ProductId = product.ProductId,
          Product = product.Product,
          ProductFullName = product.ProductFullName;
        return {
          value: ProductId,
          label: "".concat(Product, " ").concat(ProductFullName)
        };
      });
      productOptions.unshift({
        value: 'All',
        label: 'All'
      });
      var showAllProducts = formObj.values.product === 'All' || formObj.values.product === 'all';
      var productSelectorStyleOptions = ['product'];
      if (!selectedProduct) {
        productSelectorStyleOptions.push('without-icon');
      }
      return /*#__PURE__*/_react["default"].createElement("form", {
        onSubmit: handleSubmit,
        className: bemClasses('container')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('header')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('left-container')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('selector-container', productSelectorStyleOptions)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('product-icon')
      }, productManifest.manifest && selectedProduct && /*#__PURE__*/_react["default"].createElement(_ProductIconContainer["default"], {
        size: 28,
        iconFileName: Object.keys(productManifest.manifest).indexOf(selectedProduct.Product) === -1 ? selectedProduct.Product + 'DEFAULT_ICON' : productManifest.manifest[selectedProduct.Product].iconFileName
      })), /*#__PURE__*/_react["default"].createElement(_APSelect["default"], {
        name: "product",
        onSelect: function onSelect(value) {
          return selectPositionAndSave(parseInt(value, 10));
        },
        customClass: bemClasses(),
        showTriangles: true,
        options: productOptions
      })), this.renderComponentSelector()), /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('right-container')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('date-pickers-container')
      }, /*#__PURE__*/_react["default"].createElement(_APDatePicker["default"], {
        name: "startDate",
        customClass: bemClasses('from'),
        label: t('Date range:'),
        format: function format(value) {
          return value;
        },
        maxDate: new Date()
      }), /*#__PURE__*/_react["default"].createElement(_APDatePicker["default"], {
        name: "endDate",
        customClass: bemClasses('to'),
        label: t('to'),
        format: function format(value) {
          return value;
        },
        parse: function parse(value) {
          return (0, _dateFns.endOfDay)(value);
        },
        maxDate: new Date()
      })), /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
        customClass: bemClasses(),
        classModifiers: "clear-filters",
        type: "button",
        onClick: function onClick() {
          return clearFilter(products[0].ProductId);
        }
      }, t('Clear')))), component({
        dateFrom: formObj.values.startDate,
        dateTo: formObj.values.endDate,
        filterBySelectedProduct: !showAllProducts
      }));
    }
  }]);
}(_react["default"].Component);
ActivityPageComponent.propTypes = {};
var _default = exports["default"] = (0, _reactRouterDom.withRouter)((0, _reactI18next.withTranslation)('activity')(ActivityPageComponent));